// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyB_n00sFcKJZk17dpjAXmocRqhMO5v8Ano',
    authDomain: 'foodiesapp-16774.firebaseapp.com',
    databaseURL: 'https://foodiesapp-16774.firebaseio.com',
    projectId: 'foodiesapp-16774',
    storageBucket: 'foodiesapp-16774.appspot.com',
    messagingSenderId: '657398086456',
    appId: '1:657398086456:web:adc95e5c3dc635abd69fcd',
    measurementId: 'G-07CJCFW7RD'
  },
  onesignal: {
    appId: '08467d17-e40f-4184-bbb4-2242ad4c8793',
    googleProjectNumber: '657398086456',
    restKey: 'NWRiMzk4Y2EtZDJkOS00OWY1LWIzNDQtM2Y2OGQ2ZjAyZDAy'
  },
  general: {
    symbol: '₹',
    code: 'INR'
  },
  payumoney: {
    salt: '7HodQYFBT0ORiOw0FiDB0brVwZWw5Qh1',
    key: 'WkOJdh',
    surl: 'http://payu.aditbox.com/success.php',
    furl: 'http://payu.aditbox.com/failure.php',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
